import { Switch } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { useStoreState } from "easy-peasy";
import React from "react";

export default function ArchiveSwitch({ onChange, authSubject, ...rest }) {
  const { abilities } = useStoreState((state) => state.auth);

  return AuthCheck(abilities, AUTH_ACTIONS.READ_ARCHIVE, authSubject) ? (
    <Switch
      {...rest}
      checkedChildren="Arşivi Gizle"
      unCheckedChildren="Arşivi Göster"
      defaultChecked={false}
      onChange={(checked, event) => onChange(checked)}
    />
  ) : null;
}
